<div class="tenant-custom-form-sended">
    <h1 class="tenant-custom-form-sended-title">
        ¡Muchas gracias!
    </h1>
    <span class="tenant-custom-form-sended-description">
        Estaremos en contacto con usted a la brevedad para continuar con su garantía.
    </span>
    <img src="/assets/images/scoring-result/approved/approved.png" alt="" class="approved-image">
</div>
